import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import UserProcesses, { UserProcessesColumn } from '../ReusableComponents/UserProcesses';
import PortalAccess from '../ReusableComponents/PortalAccess';
import { frontendUrl } from '../MinhaOrganizadora/frontendUrls';
import PermissionGate from '../ReusableComponents/PermissionGate';
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { getNumerosInscricao } from "../../Auxiliar/Inscricao";



const Candidatos = props => {

    const [lesson_cards, SetLessonCards] = useState(null);
    const [loading_screen, setLoadingScreen] = useState(true);
    const [loading_candidatos, setLoadingcandidatos] = useState(false);
    const [search_oficial, setSearchOficial] = useState('');

    const [candidatos, setcandidatos] = useState([]);
    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



    const [search, setSearch] = useState('');
    const { faculdade_id,faculdade_name,slug } = props;
    const [show_warning, setShowWarning] = useState(false);
    const [candidato_id, setcandidatoId] = useState(null);


    const [questaoSelect, setQuestaoSelect] = useState({});

    const [showModal, setShowModal] = useState(false);
    const [processesUser, setProcessesUser] = useState(null);
    let refs = [];
    const dispatch = useDispatch();

    const Getcandidatos = async (page, search) => {

        let response = await Request.Get(`faculdade/get_candidatos/${faculdade_id}?page=${page}&search=${search}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message']=='Unauthenticated.') {
            dispatch(logout());
            return;
        }
        if (response.pagination.current_page == page) {
           
            setcandidatos(response.alunos);

            setPagination(response.pagination);
            setLoadingScreen(false);
            setLoadingcandidatos(false);

           
        }
    }

    const Deletecandidato = async (candidato_id) => {

        let response = await Request.Delete(`faculdade/delete_candidato/${candidato_id}`);
        console.log(response);
        if (response === undefined) return;

        if (response['message']=='Unauthenticated.') {
            dispatch(logout());
            return;
        }
        Getcandidatos(pagination.current_page, search_oficial);



    }
    const user = useSelector(state=>state.AppReducer.user);

    useEffect(() => {
        Getcandidatos(1, search_oficial);
    }, []);

    let pesquisarTimeout = null;
    const history = useHistory();
    return (
        <div className="row">
            <UserProcesses selected={processesUser} onHide={() => setProcessesUser(null)}  changeText={user?.empresa?.change_text} />

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>

                {user?.empresa?.online_proccess==true && <PortalAccess title="Portal do Candidato" href={frontendUrl('candidato', { frontend_urls: props.frontend_urls }, slug + '/login')} />}

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="flex jcsb flex-wrap mb-4" style={{marginTop:'1rem'}}>

                        <Search placeholder="Pesquisar pelo nome/cpf/número de inscrição do candidato" ValueChange={value => {
                            clearTimeout(pesquisarTimeout);
                            setSearchOficial(value);

                            pesquisarTimeout = setTimeout(() => {
                                let page = { ...pagination };
                                page.current_page = 1;
                                setPagination(pagination);
                                setLoadingcandidatos(true);

                                Getcandidatos(1, value)

                            }, 500);
                        }} />

                        
                                {(user.role=='region_admin' || (user.empresa==null || user.empresa.can_add)) && <PermissionGate module="candidatos" action="create"><Link to={{
                                    pathname: "/candidatos/register/" + faculdade_id,
                                    // state: {
                                    //     course_id: id
                                    // }
                                }} style={{ textDecoration: "none" }}>
                                    <Button variant="success" className="flex align-center jcc"><FaListAlt style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Adicionar candidato</p></Button>
                                </Link></PermissionGate>}
                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <ResponsiveTable id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>Nome</th>
                                        <th>E-mail</th>
                                        <th>{user?.empresa?.change_text ? 'Vagas/Cargos' : 'Processos seletivos'}</th>
                                        <th>CPF</th>
                                        <th>Número de inscrição</th>
                                        <th>Primeiro Login</th>
                                        <th>Data de nascimento</th>
                                        <th className="hidethis" data-priority="3">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_candidatos == false && candidatos.map((item, id) => (

                                        <tr key={id}>
                                            <td>{item.name}</td>
                                            <td>{item.email}</td>
                                            <td><UserProcessesColumn processes={item.processos} /></td>
                                            <td>{item.cpf}</td>
                                            <td>{getNumerosInscricao(item).join(', ')}</td>
                                            <td>{item.first_last==null?'Nunca fez login': moment(item.first_last.first,'YYYY-MM-DD').format('DD/MM/YYYY')}</td>

                                            <td>{moment(item.nascimento,'YYYY-MM-DD').format('DD/MM/YYYY')}</td>

                                            <td className="hidethis">
                                                <PermissionGate module="candidatos" action="view"><button type="button" onClick={event => { event.stopPropagation(); setProcessesUser(item); }} className="inline-flex align-center jcc bg-warning icon" style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", border: 0 }} title="Ver candidato" aria-label={`Ver candidato ${item.name}`}><BsFillEyeFill size={17} color="white" /></button></PermissionGate>
                                                {/* <span
                                                    onClick={() => {
                                                       
                                                    }}
                                                    className="inline-flex align-center jcc bg-warning icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Gerenciar candidato"
                                                >
                                                    <BsFillEyeFill size={17} color="white" />
                                                </span> */}
                                                {(user.role=='region_admin' || (user.empresa==null || user.empresa.can_edit)) && <PermissionGate module="candidatos" action="edit"><Link to={`/candidatos/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                                    <span
                                                        className="inline-flex align-center jcc bg-info icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                                                        data-toggle="tooltip"
                                                        title="Editar questão"
                                                    >
                                                        <MdModeEdit color="white" size={17} />
                                                    </span>
                                                </Link></PermissionGate>}
                                                {(user.role=='region_admin' || (user.empresa==null || user.empresa.can_exclude)) && <PermissionGate module="candidatos" action="delete"><span
                                                    onClick={(e) => {
                                                        setcandidatoId(item.id);
                                                        setShowWarning(true);
                                                        e.stopPropagation();
                                                    }}
                                                    className="inline-flex align-center jcc bg-danger icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Deletar candidato"
                                                >
                                                    <MdDelete size={17} color="white" />
                                                </span></PermissionGate>}
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </ResponsiveTable>
                            {loading_candidatos == true &&
                                <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress/>
                                </div></div>

                            }
                        </div>
                    </div>
                    {loading_candidatos == false && candidatos.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhum candidato encontrado</p>

                        </div>
                    </div>}

                    <Pagination
                        className={(pagination.last_page == 1 ? "hide" : "") + " hidethis"}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={pagination.last_page}
                        value={pagination.current_page}
                        onChange={(_, value) => {
                            setLoadingcandidatos(true);
                            console.log(_, value);
                            let page = { ...pagination };
                            page.current_page = value;
                            setPagination(pagination);
                            Getcandidatos(value, search_oficial)
                        }}
                    />

                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_candidato={this.get_candidato.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                    <CircularProgress/>
                </div></div>}

                <SweetAlert
                    warning
                    title={"Atenção"}
                    onConfirm={() => {
                        setShowWarning(false);
                        setLoadingcandidatos(true);
                        Deletecandidato(candidato_id);
                        // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                        setShowWarning(false);
                    }}
                    show={show_warning}
                    confirmBtnText='Sim, desejo apagar'
                    cancelBtnText='Cancelar'
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    Ao deletar este candidato, ele não estará mais disponível no sistema
                </SweetAlert>


            </div>

        </div>
    )
}

export default Candidatos;
